import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider, useSnackbar } from 'notistack';

const originalFetch = window.fetch.bind(window);
let isHandlingUnauthorized = false;

const clearAuthSession = () => {
    localStorage.removeItem("userid");
    localStorage.removeItem("username");
    localStorage.removeItem("roleid");
    localStorage.removeItem("tcn");
    localStorage.removeItem("Name");
    localStorage.removeItem("Photo");
    localStorage.clear();
};

window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    if (response.status === 401 && !isHandlingUnauthorized) {
        isHandlingUnauthorized = true;
        clearAuthSession();

        if (window.location.pathname !== '/login') {
            window.dispatchEvent(new CustomEvent('app:unauthorized'));
        }
        else {
            isHandlingUnauthorized = false;
        }
    }

    return response;
};

function UnauthorizedSessionHandler() {
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const onUnauthorized = () => {
            enqueueSnackbar('Session expired, please login again', { variant: 'warning' });
            setTimeout(() => {
                window.location.replace('/login');
            }, 1200);
        };

        window.addEventListener('app:unauthorized', onUnauthorized);

        return () => {
            window.removeEventListener('app:unauthorized', onUnauthorized);
        };
    }, [enqueueSnackbar]);

    return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
    >
        <UnauthorizedSessionHandler />
        <App />
    </SnackbarProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
